// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__KWJCS","content":"styles_content___iK_8","subtitle":"styles_subtitle__B92oJ"};